export default "__VITE_ASSET__95c78a98__"